import { useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { ASSETS } from "@/lib/assets";

export const SoundToggle = () => {
  const ref = useRef(null);
  const [on, setOn] = useState(false);

  if (!ASSETS.soundtrack) return null;

  const toggle = () => {
    const a = ref.current;
    if (!a) return;
    if (on) {
      a.pause();
      setOn(false);
    } else {
      a.volume = 0.35;
      a.play().catch(() => {});
      setOn(true);
    }
  };

  return (
    <>
      <audio ref={ref} src={ASSETS.soundtrack} loop preload="none" />
      <button
        onClick={toggle}
        data-testid="sound-toggle"
        aria-label="Toggle ambient soundtrack"
        data-cursor="view"
        className="fixed bottom-6 left-6 z-[110] flex items-center gap-3 border border-evo-gold/40 bg-evo-black/70 backdrop-blur-md px-4 py-3 text-evo-gold hover:border-evo-gold transition-colors duration-300"
      >
        {on ? <Volume2 size={16} /> : <VolumeX size={16} />}
        <span className="text-[10px] uppercase tracking-[0.2em]">{on ? "Sound On" : "Sound"}</span>
        {on && (
          <span className="flex items-end gap-[2px] h-3.5" aria-hidden>
            <span className="evo-eq-bar" style={{ animationDelay: "0ms" }} />
            <span className="evo-eq-bar" style={{ animationDelay: "160ms" }} />
            <span className="evo-eq-bar" style={{ animationDelay: "320ms" }} />
          </span>
        )}
      </button>
    </>
  );
};
